import Vue from 'vue';
import Component from 'vue-class-component';
import { Emit, Prop, Watch } from 'vue-property-decorator';
import EdInputModel from '@/models/ed-input.model';

@Component({
  name: 'ed-deck-card-change-name-modal',
})
export default class EdDeckCardChangeNameModal extends Vue {

  @Prop() readonly params: any;

  name = EdInputModel('name',  '');

  emitOnSave() {
    this.params.onSave(this.name.value);
  }

  closeModal(): void {
    this.$EdModal.closeModal();
  }

  mounted() {
    this.name.value = this.params.cardName;
  }
}
